module.exports = __webpack_public_path__ + "static/media/OutliersQ5_3.92f01438.svg";